"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.promptsTableCols = void 0;
exports.promptsTableColsWithOptions = promptsTableColsWithOptions;
exports.webhookActionFilterOptions = webhookActionFilterOptions;
const types_1 = require("../features/prompts/types");
const typeHelpers_1 = require("./typeHelpers");
exports.promptsTableCols = [
    {
        name: "ID",
        id: "id",
        type: "string",
        internal: 'p."id"',
    },
    {
        name: "Name",
        id: "name",
        type: "string",
        internal: 'p."name"',
    },
    {
        name: "Version",
        id: "version",
        type: "number",
        internal: 'p."version"',
    },
    {
        name: "Created At",
        id: "createdAt",
        type: "datetime",
        internal: 'p."created_at"',
    },
    {
        name: "Updated At",
        id: "updatedAt",
        type: "datetime",
        internal: 'p."updated_at"',
    },
    {
        name: "Type",
        id: "type",
        type: "stringOptions",
        internal: 'p."type"',
        options: Object.values(types_1.PromptType).map((value) => ({ value })),
    },
    {
        name: "Labels",
        id: "labels",
        type: "arrayOptions",
        internal: 'p."labels"',
        options: [], // to be added at runtime
    },
    {
        name: "Tags",
        id: "tags",
        type: "arrayOptions",
        internal: 'p."tags"',
        options: [], // to be added at runtime
    },
    {
        name: "Config",
        id: "config",
        type: "stringObject",
        internal: 'p."config"',
    },
];
function promptsTableColsWithOptions(options) {
    return exports.promptsTableCols.map((col) => {
        if (col.id === "tags") {
            return (0, typeHelpers_1.formatColumnOptions)(col, options?.tags ?? []);
        }
        if (col.id === "labels") {
            return (0, typeHelpers_1.formatColumnOptions)(col, options?.labels ?? []);
        }
        return col;
    });
}
function webhookActionFilterOptions(options) {
    return promptsTableColsWithOptions(options).filter((col) => ["name", "labels", "tags"].includes(col.id));
}
